const initialState = {
  selectedTree: null,
  selectedTreeId: null
}

export const context = {
  namespaced: true,
  state: initialState,
  actions: {
    treeSelectionChanged({ commit }, item) {
      console.log("select "+item)
      commit('selectTree', item);
    }
  },
  mutations: {
    selectTree(state, item) {
      if (item.type=="driver") state.selectedTreeId = item.obj.username
      if (item.type=="company") state.selectedTreeId = item.obj.companyName
      state.selectedTree = item.obj
    },
  }
};
